import React, { useState, useEffect } from "react";
import commoncss from "../../css/common.module.css";
import FixedAssetSideBar from "../../components/fixedasset/FixedAssetSideBar";
import FaRegHeader from "../../fixedassetelements/Headers/FaHeaders";
import DataState from "../../fixedassetelements/common/DataState/DataState";
import ERPTable from "../../fixedassetelements/table/ERPTable";
import FixedAssetTable from "../../fixedassetelements/table/FixedAssetsTable";

const FixedAssetListing = () => {
  const [showDataState, setShowDataState] = useState(true);
  const [tableType, setTableType] = useState(null);
  const [showTable, setShowTable] = useState(false);
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [showAddRegisterModal, setShowAddRegisterModal] = useState(false);
     
 
  useEffect(() => {
    if (showTable && tableType === null) {
      setTableType("excel");
    }
  }, [showTable, tableType]);

   const handleFiltersApplied = (filters) => {
   setAppliedFilters(filters);
  };


    return (
    <div style={{ display: "flex" }}>
      <FixedAssetSideBar activeTab={"Listing"} />

      <div className={`${commoncss.widthScrHidden} px-3 py-2`}>
        <FaRegHeader
          setShowDataState={setShowDataState}
          tableType={tableType}
          setTableType={setTableType}
          setShowTable={setShowTable}
          showAddRegisterModal={showAddRegisterModal}
          setShowAddRegisterModal={setShowAddRegisterModal}
        />

        {showDataState && !showTable && <DataState  setShowAddRegisterModal={setShowAddRegisterModal} />}

        {showTable && tableType === "excel" && <FixedAssetTable filters={appliedFilters} />}
        {showTable && tableType === "erp" && <ERPTable />}
      </div>
    </div>
  );
};

export default FixedAssetListing;
